import BsjSetMileageModal from './bsj-set-mileage-modal.vue'
export default BsjSetMileageModal
